import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SousBien } from 'app/models/sousBien';
import { Observable, Subject, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SousBienService {

  base_path = 'https://app.titv-store-api.com/';

  constructor(private http: HttpClient) { }
  
  private refreshData = new Subject<void>();
  
  get refreshNedeed() {
    return this.refreshData;
  }

  // ✅ MÊME MÉTHODE TOKEN
  private getToken(): string {
    try {
      const authUser = sessionStorage.getItem('auth-user');
      if (authUser) {
        const userObj = JSON.parse(authUser);
        return userObj.token || '';
      }
      return '';
    } catch {
      return '';
    }
  }

  // ✅ MÊME MÉTHODE HEADERS
  private getHeaders(): HttpHeaders {
    const token = this.getToken();
    
    if (token) {
      return new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      });
    }
    
    return new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }

  // ✅ MÊME MÉTHODE ERROR HANDLING
  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Une erreur est survenue';
    
    if (error.status === 403) {
      errorMessage = `Accès interdit. Token: ${this.getToken() ? 'présent' : 'absent'}`;
    } else if (error.status === 401) {
      errorMessage = 'Non autorisé. Veuillez vous reconnecter.';
    } else {
      errorMessage = `Erreur ${error.status}: ${error.message}`;
    }
    
    console.error('Erreur SousBienService:', errorMessage);
    return throwError(() => new Error(errorMessage));
  }

  createSousBien(item: any, idProduit: any): Observable<SousBien> {
    const headers = this.getHeaders();
    
    return this.http.post<SousBien>(
      this.base_path + 'biens/sous/add/' + idProduit, 
      JSON.stringify(item), 
      { headers }
    ).pipe(
      tap(() => {
        this.refreshData.next();
      }),
      catchError(this.handleError)
    );
  }

  // Get single SousBien data by ID
  getSousBien(id: any): Observable<SousBien> {
    const headers = this.getHeaders();
    
    return this.http.get<SousBien>(
      this.base_path + 'biens/sous/' + id,
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }

  // Get SousBiens data
  getListSousBien(): Observable<SousBien[]> {
    const headers = this.getHeaders();
    
    return this.http.get<SousBien[]>(
      this.base_path + 'biens/sous/all',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }

  // Get SousBiens data
  getListSousMeilleursBien(): Observable<SousBien[]> {
    const headers = this.getHeaders();
    
    return this.http.get<SousBien[]>(
      this.base_path + 'biens/sous/all/mb',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }

  // Update item by id
  updateSousBien(id: any, item: any): Observable<SousBien> {
    const headers = this.getHeaders();
    
    return this.http.put<SousBien>(
      this.base_path + 'biens/sous/update/' + id, 
      JSON.stringify(item), 
      { headers }
    ).pipe(
      tap(() => {
        this.refreshData.next();
      }),
      catchError(this.handleError)
    );
  }

  // Delete item by id
  deleteSousBien(id: any): Observable<any> {
    const headers = this.getHeaders();
    
    return this.http.delete<any>(
      this.base_path + 'biens/sous/delete/' + id, 
      { headers }
    ).pipe(
      tap(() => {
        this.refreshData.next();
      }),
      catchError(this.handleError)
    );
  }

  getBiensById(idBiens: number) {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'biens/' + idBiens,
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }

  // sous-bien.service.ts (add this method)
updateSousBiensOrderBatch(updates: { id: number; displayOrder: number }[]): Observable<any> {
  const headers = this.getHeaders();
  return this.http.put(
    this.base_path + 'biens/sous/order',
    updates,
    { headers, responseType: 'text' }
  ).pipe(
    tap(() => this.refreshData.next()),
    catchError(this.handleError)
  );
}
}